export default __webpack_public_path__ + "static/media/maths-card-bg.8e516768.svg";